<template>
    <!--故障视图-->
    <div class="physical-item">
        <div class='menu-item title' @click="openFaultData">故障</div>
        <div class='menu-item icon-wrap' @click="openHistoryFaultData"><i class='iconfont icon-set'>&#xe60c;</i></div>
        <!--显示故障列表-->
        <div class="fault-table" v-if="historyMode">
            <div class="close" @click="closeHistoryFaultData">
                <i class="iconfont">&#xe618;</i>
            </div>
            <el-table ref="faultTable" class="fault-content"
                :data="faultDataList"
                border
                max-height="300"
                style="width: 100%"
                highlight-current-row
                @row-click="faultTableClick">
                <el-table-column
                    label="颜色"
                    width="80">
                    <template slot-scope="scope">
                        <div :style="{background:scope.row.color}" class="color"></div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="title"
                    label="报警内容">
                </el-table-column>
                <el-table-column
                    prop="starttime"
                    label="开始时间"
                    :formatter="formatterTableColumn"
                >
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';

import {pipelineFaultData} from "@api/map2d";

export default {
    name:"fault",
    props:['mainmap','pipelineConfig','pipelineFeatureArray','stationConfig'],
    data(){
        return {
            currentTimeId:null, // 定时器获取管道的故障数据
            featureColorFlag:false, // 管道颜色标志
            faultFeatureArray:[], // 报警管道

            faultDataList:[],// 故障列表
            historyMode:false, //历史记录是否开启

            notifyPanels:[], //通知框
        }
    },
    mounted(){
        this.$nextTick(()=>{
            // 获取管道故障数据
            // this.getPipelineFaultData();
        });
    },
    methods:{
        // 打开故障视图
        openFaultData(){
            // 修改当前的模式
            this.$set(this.stationConfig.pattern,"name","fault");

            // 高亮显示
            this.$el.classList.add("selected");
            // 取消同层显示,不知道为什么下面的代码会影响到温度等的状态，暂时未解决
            //取出父層第一個子元素
            // let sibling = this.$el.parentNode.firstChild;
            // //如果有sibling子元素執行迴圈
            // while (sibling) {
            // //節點類型為元素節點 且 sibling不等於自己
            //     if (sibling.nodeType === 1 && sibling != this.$el) {
            //         sibling.classList.remove("selected");
            //     }
            //     //找siblings下一個同層元素
            //     sibling = sibling.nextSibling;
            // }

            // 清空管线上的原有的样式
            let featureArray=this.pipelineFeatureArray;
            for(let i=featureArray.length-1;i>=0;i--){
                let feature=featureArray[i];
                feature.set("fault","");
                feature.setStyle(this.pipelineStyleFun(feature));
            }
            // 获取管道故障数据
            this.getPipelineFaultData();

            // 触发事件
            this.$emit("openFaultData");
        },
        // 获取实时数据
        timingDrawData(){
            let that=this;
            // 清空定时器
            if(that.currentTimeId){
                clearTimeout(that.currentTimeId);
                that.currentTimeId=null;
            }
            // 判断当前路由是否为智慧管网，如果不是，则应该取消定时器
            if(this.$route.name!="mapShow"||this.stationConfig.pattern.name!="fault"){
                // 去掉高亮显示
                this.$el.classList.remove("selected");

                // 关闭通知栏
                if(this.notifyPanels.length>0){
                    for(let t in this.notifyPanels){
                        let notify=this.notifyPanels[t];
                        notify.close();
                    }
                }
                // 关闭历史
                this.historyMode=false;
                // 取消定时器
                if(that.currentTimeId){
                    clearTimeout(that.currentTimeId);
                    that.currentTimeId=null;
                }
                return;
            }
            that.currentTimeId=setTimeout(async function(){
                // 定时器调用实时数据
                if(that.currentTimeId){
                    clearTimeout(that.currentTimeId);
                    that.currentTimeId=null;

                    // 获取实时数据
                    that.featureAnimationFrame();

                    // 重启定时器
                    that.timingDrawData();
                }else{
                    // 获取实时数据
                    that.featureAnimationFrame();

                    // 重启定时器
                    that.timingDrawData();
                }
            },2*1000);
        },

        // 获取故障数据
        getPipelineFaultData(){
            let that=this;
            // 获取管道的故障数据
            pipelineFaultData().then(data=>{
                if(data.status==200){
                    let content=data.content;
                    that.faultDataList=content;

                    let faultD=content[0]; // 第一条故障数据
                    
                    // 显示通知
                    let notifyPanel=this.$notify({
                        title: '故障报警',
                        type: 'warning',
                        dangerouslyUseHTMLString: true,
                        message:'<div class="fault-message">'+
                                '<div class="item">'+
                                    '<span class="label">警示色:</span>'+
                                    '<span class="color" style="display:inline-block;background:'+faultD.color+';width:60px;height:10px;"></span>'+
                                '</div>'+
                                '<div class="item">'+
                                    '<span class="label">开始时间:</span>'+
                                    '<span>'+faultD.starttime+'</span>'+
                                '</div>'+
                                '<div class="item">'+
                                    '<span class="label">详情:</span>'+
                                    '<span>'+faultD.title+'</span>'+
                                '</div>'+
                                '<div class="item">'+
                                    '<span class="label">区间:</span>'+
                                    '<span>'+faultD.startindex+"——"+faultD.endindex+'</span>'+
                                '</div>'+
                            '</div>',
                        duration: 0
                    });
                    // 保存通知栏
                    this.notifyPanels.push(notifyPanel);

                    // 绘制管道样式
                    that.pipelineDrawFault(faultD);

                    // 高亮第一条
                    if( this.$refs.faultTable){
                        this.$refs.faultTable.setCurrentRow(faultD);
                    }
                }

            })
        },
        // 计算管道样式
        pipelineDrawFault(data){
            let that=this;
            let startFault=data.startindex; // 异常数据开始编号
            let endFault=data.endindex; // 异常数据结束编号
            let colorFault=data.color;// 异常数据颜色
            //遍历所有的线段,获取线段编号，然后根据线段编号从线段配置文件中读取相应的数据，根据起始和终点相减获取到数据长度，然后在实时数据中取相应的长度数据对应
            let featureArray=that.pipelineFeatureArray;
            that.faultFeatureArray=[]; // 清空数组 
            for(let i=featureArray.length-1;i>=0;i--){
                let feature=featureArray[i];

                let featureProperties=feature.getProperties();
                // 获取线段编号
                let linenumber=featureProperties.number||featureProperties.Number;
                // 管线配置不存在
                if(!that.pipelineConfig){
                    break;
                }
                let lineConfig=that.pipelineConfig[linenumber];
                //如果线段中有配置项，则根据配置项进行绘制
                if(lineConfig){
                    // 子编号在线段的配置文件里面，则获取数据
                    let subNumber=featureProperties.subnumber||featureProperties.SubNumber;
                    let sublineArray=lineConfig.sublineArray;
                    for(let j=sublineArray.length-1;j>=0;j--){
                        let subLineConfig=sublineArray[j];
                        let startNumber=subLineConfig.startIndex;
                        let endNumber=subLineConfig.endIndex;
                        if(subNumber>=startNumber&&subNumber<=endNumber){
                            // 获取每一段地图上的管线对应的管线实时数据的偏移量
                            // 偏移量=当前线段的子编号-线段配置文件中的开始编号+线段配置文件中的数据开始偏移量
                            let offsetIndex=subNumber-startNumber+subLineConfig.dindex;
                            if(offsetIndex>=startFault&&offsetIndex<=endFault){
                                //获取到真实数据后，根据数据绘制内容
                                feature.set("fault",colorFault);
                                feature.setStyle(that.pipelineStyleFun(feature));
                                // 保存报警管道
                                that.faultFeatureArray.push(feature);
                            }

                        }
                    }
                }
            }
            // 启动动画
            that.timingDrawData();
        },
        //绘制管线样式
        pipelineStyleFun(feature,auto) {
             let featureProperties=feature.getProperties();
            //根据当前配置项，显示数据
            let currentValue=featureProperties.fault;
            if(auto){
                if(!currentValue){
                    currentValue="#949494" ;
                }
            }else{
                currentValue="#949494" ;
            }

            let style=new Style({
                stroke: new Stroke({
                    color: currentValue,
                    width:5,
                    lineCap:"square"
                })
            });
            return style;
        },

        // 开启定时动画
        featureAnimationFrame(){
            this.featureColorFlag=!this.featureColorFlag;
            let featureArray=this.faultFeatureArray;
            for(let i=featureArray.length-1;i>=0;i--){
                let feature=featureArray[i];
                feature.setStyle(this.pipelineStyleFun(feature,this.featureColorFlag));
            }
        },
        // 格式化table列
        formatterTableColumn(row,column,cellValue){
            return cellValue.replace(" ","\n"); 
        },
        // 故障列表点击
        faultTableClick(row){
            this.featureColorFlag=!this.featureColorFlag;

            // 清空管线上的原有的样式
            let featureArray=this.faultFeatureArray;
            for(let i=featureArray.length-1;i>=0;i--){
                let feature=featureArray[i];
                feature.set("fault","");
                feature.setStyle(this.pipelineStyleFun(feature));
            }
            // 绘制管道样式
            this.pipelineDrawFault(row);
        },

        // 打开历史记录
        openHistoryFaultData(){
            this.historyMode=true;

            this.$el.classList.add("selected");

            // 修改当前的模式
            this.$set(this.stationConfig.pattern,"name","fault");

            // 清空管线上的原有的样式
            let featureArray=this.pipelineFeatureArray;
            for(let i=featureArray.length-1;i>=0;i--){
                let feature=featureArray[i];
                feature.set("fault","");
                feature.setStyle(this.pipelineStyleFun(feature));
            }

            // 获取故障数据
            if(this.faultDataList.length<=0){
                this.getPipelineFaultData();
            }else{
                console.log("dsf");
                // 高亮第一条
                this.$nextTick(()=>{
                    if( this.$refs.faultTable){
                        let faultD=this.faultDataList[0];
                        this.$refs.faultTable.setCurrentRow(faultD);
                        // 点击第一条
                        this.faultTableClick(faultD);
                    }
                });
            }

        },
        // 关闭历史记录
        closeHistoryFaultData(){
            this.historyMode=false;
        }
    },
}
</script>
<style lang="scss">
.fault-table{
    max-width: 500px;
    min-width: 350px;
    position:fixed;
    bottom:10px;
    right: 20px;
    // 单元格内容居中
    .el-table td,.el-table th {
        text-align: center !important;
    }

    /** 时间列的单独配置 */
    .el-table .cell{
        word-break:initial;
        white-space: pre;
    }

    .color{
        width:60px;
        height: 10px;
    }

    .close{
        position: absolute;
        z-index: 1;
        right: -10px;
        top: -30px;
        background: #fff;
        padding: 10px;
        border-radius: 30px;
        cursor: pointer;
        width: 40px;
        line-height: 20px;
    }
}
.fault-history{
    position: fixed;
    right: 10px;
    bottom: 20px;
    width: 40px;
    height: 40px;
    background: #fff;
    color: #2aade4;
    border-radius: 30px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;

    i{
        font-size: 25px;
    }
}
.fault-message{
    .label{
        font-weight: 600;
        font-size: 15px;
    }
}
</style>